const style = {
  container: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "280px",
    height: "100vh",
    backgroundColor: "rgba(22, 27, 34, 0.8)",
    borderRight: "1px solid #30363D",
    backdropFilter: "blur(10px)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    padding: "24px",
    boxSizing: "border-box",
    zIndex: 10,
  },
  logo: {
    fontSize: "22px",
    fontWeight: "600",
    color: "#E6EDF3",
    display: "flex",
    alignItems: "center",
    justifyContent:"center",
    flexDirection: "column",
  },
  logoImage: {
    width: "100px",    
    height: "100px",
    borderRadius: "50%",
    objectFit: "cover", 
    filter: "drop-shadow(5px 3px 20px rgba(0, 200, 220, 0.2))"
  },
  mainNav: {
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    gap: '40px',
  },
  menuTitle: {
    fontSize: "12px",
    fontWeight: "bold",
    color: "#8B949E",
    padding: "0 16px",
    marginBottom: "10px",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
  },
  nav: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  navItem: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "12px 16px",
    textDecoration: "none",
    color: "#8B949E",
    fontSize: "15px",
    fontWeight: "500",
    borderRadius: "8px",
    transition: "background-color 0.2s ease, color 0.2s ease",
  },
  navItemActive: {
    backgroundColor: "rgba(88, 166, 255, 0.1)",
    color: "#58A6FF",
  },
  navItemIcon: {
    fontSize: "20px",
  },
  bottomSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px'
  },
  logoutButton: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "12px 16px",
    width: '100%',
    background: 'transparent',
    border: '1px solid #30363D',
    color: "#CD4C4C",
    fontSize: "15px",
    fontWeight: "500",
    borderRadius: "8px",
    cursor: 'pointer',
    transition: "background-color 0.2s ease, border-color 0.2s ease",
  },
  footerCard: {
    backgroundColor: "rgba(88, 166, 255, 0.1)",
    borderRadius: "16px",
    padding: "20px",
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  footerCircle: {
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    backgroundColor: "#58A6FF",
    color: "#0D1117",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "20px",
    fontWeight: "bold",
    marginBottom: "16px",
  },
  footerTitle: {
    margin: "0 0 8px 0",
    color: "#E6EDF3",
    fontWeight: "600",
  },
  footerText: {
    margin: "0 0 16px 0",
    color: "#8B949E",
    fontSize: "13px",
  },
  footerButton: {
    backgroundColor: "#E6EDF3",
    color: "#0D1117",
    border: "none",
    borderRadius: "8px",
    padding: "10px 20px",
    width: "100%",
    cursor: "pointer",
    fontWeight: "bold",
    fontSize: "14px",
  },
};

export default style;